<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

onMounted(() => {
  // Load Phosphor Icons
  const script = document.createElement('script')
  script.src = 'https://unpkg.com/@phosphor-icons/web'
  document.head.appendChild(script)
})
</script>